module.exports = __webpack_public_path__ + "static/media/pokerPhone2.37add3b4.svg";